import { render, staticRenderFns } from "./L2IPComp.vue?vue&type=template&id=7b47f38c&"
import script from "./L2IPComp.vue?vue&type=script&lang=js&"
export * from "./L2IPComp.vue?vue&type=script&lang=js&"
import style0 from "./L2IPComp.vue?vue&type=style&index=0&id=7b47f38c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports